/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 27.04.2016.
 */
import DivLoader from './div-loader';

export default DivLoader;



// WEBPACK FOOTER //
// ./src/components/DivLoader/index.js